import axios from 'axios';

// Keep the admin authority separate from the impersonated partner session.
const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 15000,
});

function authorization() {
  const token = localStorage.getItem('admin_token');
  if (!token || token === 'null') throw new Error('La sesión de administrador no está disponible.');
  return { Authorization: `Bearer ${token}` };
}

export async function adminAiGet(path, params = undefined) {
  const response = await client.get(`/v1/api/admin/ai${path}`, {
    headers: authorization(), params,
  });
  return response.data;
}

export async function adminAiPut(path, payload) {
  const response = await client.put(`/v1/api/admin/ai${path}`, payload, {
    headers: authorization(),
  });
  return response.data;
}

export async function adminAiPost(path, payload, options = {}) {
  const response = await client.post(`/v1/api/admin/ai${path}`, payload, { headers: authorization(), timeout: 120000, ...options });
  return response.data;
}

export async function adminAiDownload(path) {
  const response = await client.get(`/v1/api/admin/ai${path}`, { headers: authorization(), responseType: 'blob' });
  return response.data;
}

export function adminAiError(error) {
  const data = error?.response?.data;
  const detail = data?.error || data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || item.message || 'Dato inválido').join(' · ');
  return error?.message || 'No se ha podido completar la operación.';
}
